import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { x } from '@xstyled/styled-components';
import { AllPackagesButton, ContainerVertical, ExpandRightIcon, HSpacer, Section, TrackingTitle, When } from '@aftersale-next/ui';
import EventList from '../events/event-list';
import { useEcommerceEnabled, usePackageIndex } from '@aftersale-next/atoms';
import { DeliveryInfo } from '../delivery/delivery-info';
import { PackageProducts } from '../package-products/package-products';
import { useTrackingMode } from '../../hooks/use-app-mode';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { PACKAGE_PARAM_REGEX } from '../../config/constants/tracking';
export default function PackageDetails(_ref) {
  var isMultiplePackages = _ref.isMultiplePackages;

  var _useEcommerceEnabled = useEcommerceEnabled(),
      _useEcommerceEnabled2 = _slicedToArray(_useEcommerceEnabled, 1),
      isEcommerceEnabled = _useEcommerceEnabled2[0];

  var router = useRouter();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _usePackageIndex = usePackageIndex(),
      _usePackageIndex2 = _slicedToArray(_usePackageIndex, 2),
      packageIndex = _usePackageIndex2[0],
      setPackageIndex = _usePackageIndex2[1];

  var _useTrackingMode = useTrackingMode(),
      _useTrackingMode2 = _slicedToArray(_useTrackingMode, 2),
      setTrackingMode = _useTrackingMode2[1];

  var _useState = useState(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var handleShowAllPackages = function handleShowAllPackages() {
    setPackageIndex(null);
    router.push(router.asPath.replace(PACKAGE_PARAM_REGEX, ''), undefined, {
      shallow: true,
      scroll: false
    });
    setTrackingMode('packages-list');
  };

  return /*#__PURE__*/_jsxs(ContainerVertical, {
    justify: "flex-start",
    align: "flex-start",
    fullWidth: true,
    children: [isMultiplePackages && /*#__PURE__*/_jsxs(AllPackagesButton, {
      onClick: handleShowAllPackages,
      children: [t('SEE_ALL_PACKAGES'), /*#__PURE__*/_jsx(x.div, {
        ml: "auto",
        children: /*#__PURE__*/_jsx(ExpandRightIcon, {})
      })]
    }), /*#__PURE__*/_jsxs(Section, {
      children: [/*#__PURE__*/_jsx(x.div, {
        pb: "32px",
        children: /*#__PURE__*/_jsx(TrackingTitle, {
          packageIndex: packageIndex,
          isMultiplePackage: isMultiplePackages
        })
      }), /*#__PURE__*/_jsx(EventList, {})]
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "8px"
    }), /*#__PURE__*/_jsx(When, {
      value: !!isEcommerceEnabled,
      children: function children() {
        return /*#__PURE__*/_jsx(DeliveryInfo, {});
      }
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "8px"
    }), /*#__PURE__*/_jsx(PackageProducts, {
      onClick: function onClick() {
        return setIsExpanded(!isExpanded);
      },
      isExpanded: isExpanded
    })]
  });
}